export default class Enumeration {
  constructor(obj) {
    for (const key in obj) {
      this[key] = obj[key]
    }
    return Object.freeze(this)
  }
  // eslint-disable-next-line no-undef
  has = (key) => {
    return this.hasOwnProperty(key)
  }
}
